"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getElementLink = exports.getBreadCrumb = void 0;
var urls_1 = __importDefault(require("../app/urls"));
var constants_1 = require("./constants");
var getBreadCrumb = function (currentName, translate, clientConfig, task, trail) {
    var breadCrumb = [];
    breadCrumb.push({
        text: translate('header.home'),
        url: urls_1.default.inside.home,
    });
    if (task) {
        switch (task.elementGroup) {
            case constants_1.patientProgramElementGroups.main: {
                if (task.module) {
                    breadCrumb.push({
                        text: task.moduleName,
                        url: "".concat(urls_1.default.inside.program, "/").concat(task.elementGroup, "/").concat(task.elementIndex),
                    });
                }
                break;
            }
            case constants_1.patientProgramElementGroups.appointment:
            case constants_1.patientProgramElementGroups.app: {
                break;
            }
            default: {
                breadCrumb.push({
                    text: translate("patientProgramElementGroups.".concat(task.elementGroup), undefined, { onMissingTranslation: function () { return '..'; } }),
                });
            }
        }
    }
    if (trail) {
        for (var i = 0; i < trail.length; i++) {
            breadCrumb.push(trail[i]);
        }
    }
    breadCrumb.push({
        text: currentName,
    });
    return breadCrumb;
};
exports.getBreadCrumb = getBreadCrumb;
var getElementLink = function (element) { return "".concat(urls_1.default.inside.program, "/").concat(element.elementGroup, "/").concat(element.indexInGroup); };
exports.getElementLink = getElementLink;
